import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { TypedMutationConfig } from '@/lib/react-query';
import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';

/**
 * Add APK Google Play Store Channel Input Schema
 */
export const addApkGooglePlayStoreChannelValidationSchema = z.object({
  state: z.string({ required_error: 'State is required' }),
  names: z.array(z.string({ required_error: 'Names are required' })),
});

export type TAddApkGooglePlayStoreChannelValidation = z.infer<typeof addApkGooglePlayStoreChannelValidationSchema>;
export type TAddApkGooglePlayStoreChannelPayload = TAddApkGooglePlayStoreChannelValidation;
export type TAddApkGooglePlayStoreChannelResponse = ApiResponse<{
  message: string;
}>;

export const addApkGooglePlayStoreChannel = async (
  payload: TAddApkGooglePlayStoreChannelPayload
): Promise<TAddApkGooglePlayStoreChannelResponse> => {
  const url = `/integration/google-playstore/app-name`;

  const payloadData = {
    state: payload.state,
    names: payload.names,
  };

  return axiosInstance.post(url, payloadData);
};

/**
 * Use Add APK Google Play Store Channel React-Query Hook
 */
type UseAddApkGooglePlayStoreChannelOptions = {
  mutationConfig?: TypedMutationConfig<typeof addApkGooglePlayStoreChannel, AxiosErrorCustom>;
};

/**
 * Use Add APK Google Play Store Channel React-Query Hook
 */
export const useAddApkGooglePlayStoreChannel = ({ mutationConfig }: UseAddApkGooglePlayStoreChannelOptions) => {
  const { ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: addApkGooglePlayStoreChannel,
    ...restConfig,
  });
};
